/* eslint-disable react/prop-types */
import React from "react";
import { IconButton } from "@chakra-ui/react";
import { HamburgerIcon } from '@chakra-ui/icons';

const DrawerButton = ({ Disclosure, btnRef }) => {
    
    return (
        <>
        <IconButton
            size="md"
            ref={btnRef}
            icon={Disclosure.isOpen ? null : <HamburgerIcon />}
            aria-label="Open Menu"
            onClick={Disclosure.isOpen ? Disclosure.onClose : Disclosure.onOpen}
          />
            {/* <Button ref={btnRef} colorScheme='teal' onClick={Disclosure.onOpen}>
                Open
            </Button> */}
        </>
    )
}

export { DrawerButton }